"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimChargerControlErrorCodeStateValidation = void 0;
class SimChargerControlErrorCodeStateValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.error_code for existence and correct type.
        if (entity.error_code == undefined)
            return false;
        if (typeof entity.error_code !== "number")
            return false;
        return true;
    }
}
exports.SimChargerControlErrorCodeStateValidation = SimChargerControlErrorCodeStateValidation;
